import React from "react";

import MarkdownStyleQuickEditor from "./markdownStyleQuickEditor";
import {
	extractMarkdownStyleFragmentFromStylesheet,
	getStylesheetScopeSelector,
	mergeMarkdownStyleFragmentIntoStylesheet,
	stringifyJsonStyleObject
} from "../../utils/labelsStylesheetUtils";

const MarkdownStylesheetQuickEditor = ({
	stylesheetValue = "",
	onChangeStylesheet,
	scopeType = "activity",
	scopeEntity = null,
	invalidValueMessage = "Fix invalid Stylesheet JSON before using these quick Markdown style controls.",
	...rest
}) => {
	const scopeSelector = getStylesheetScopeSelector(scopeType, scopeEntity);
	const fragmentObject = extractMarkdownStyleFragmentFromStylesheet(stylesheetValue, scopeSelector);
	const fragmentValue = fragmentObject === null ? "__INVALID_JSON__" : stringifyJsonStyleObject(fragmentObject);

	return (
		<MarkdownStyleQuickEditor
			{...rest}
			stylesValue={fragmentValue}
			invalidValueMessage={invalidValueMessage}
			onChangeStyles={(nextFragmentValue) => {
				if (typeof onChangeStylesheet !== "function") {
					return;
				}
				const nextStylesheetValue = mergeMarkdownStyleFragmentIntoStylesheet(stylesheetValue, nextFragmentValue, scopeSelector);
				if (nextStylesheetValue !== null) {
					onChangeStylesheet(nextStylesheetValue);
				}
			}}
		/>
	);
};

export default MarkdownStylesheetQuickEditor;
